import * as types from './types';
import { loading, success, error } from 'State/actions';
import { replace } from 'react-router-redux';

export const fetchVendor = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VENDOR_FETCHING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `InvVendors/GetVendorById/${id}`
      );
      dispatch(
        success(types.VENDOR_FETCH, {
          vendorData: response.data.Data,
        })
      );
    } catch (ex) {
      dispatch(error(types.VENDOR_FETCH_ERROR, ex));
    }
    dispatch(loading(types.VENDOR_FETCHING, false));
  };
};

export const saveVendor = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VENDOR_SUBMITTING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate('InvVendors/WriteVendor', model);
      dispatch(success(types.VENDOR_SUBMIT));
      dispatch(replace('/vendorsetup'));
    } catch (ex) {
      dispatch(error(types.VENDOR_SUBMIT_ERROR, ex));
    }
    dispatch(loading(types.VENDOR_SUBMITTING, false));
  };
};

export const deleteVendor = vendorId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VENDOR_DELETING, true));

    try {
      await MPWWebApi.postGenericDelete('InvVendors', vendorId);
      dispatch(success(types.VENDOR_DELETE));
    } catch (ex) {
      dispatch(error(types.VENDOR_DELETE_ERROR, ex));
    }

    dispatch(loading(types.VENDOR_DELETING, false));
  };
};

export const clearVendorErrorSuccess = () => {
  return {
    type: types.VENDOR_CLEAR_ERROR_SUCCESS,
  };
};

export const clearVendorData = () => {
  return {
    type: types.VENDOR_CLEAR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/vendorDetails/actions.js